// @flow
import type {Element} from 'react'
import React from 'react'

import type {MoveItemsOptionMap, Path, UpdateCallback} from 'components/proposals/types'
import {Checkbox} from 'components/proposals/Part/ui'

import KeepDeleteSwitch from './KeepDeleteSwitch'
import MoveItems from '../MoveItems'

type Props = $ReadOnly<{
  changeKey: string,
  checked: boolean,
  destroyCircleKeepRole: boolean,
  isReadonly: boolean,
  parentCircleName: string,
  roleName: string,
  onChange: UpdateCallback,
  path: Path,
  policiesToMoveUp: MoveItemsOptionMap,
  rolesToMoveUp: MoveItemsOptionMap,
}>

function CircleV4Footer(props: Props): Element<"div"> {
  return (
    <div className="proposal-part-circle-footer">
      <div className="proposal-part-circle-footer__remove-checkbox">
        <Checkbox
          checked={props.checked}
          disabled={props.isReadonly}
          label={I18n.t('proposals.role_edit.remove_circle')}
          onChange={props.onChange}
          tabIndex={0}
          path={props.path}
        />
      </div>
      {props.checked && (
      <div className="has-danger">
        <div className="form-control-feedback">
          {I18n.t('proposals.role_edit.remove_circle_warning')}
        </div>
      </div>
      )}
      {props.checked && (
      <div className="proposal-part-circle-footer__move-items">
        <MoveItems
          changeKey={props.changeKey}
          isReadonly={props.isReadonly}
          onChange={props.onChange}
          roleName={props.roleName}
          policiesToMoveUp={props.policiesToMoveUp}
          rolesToMoveUp={props.rolesToMoveUp}
        />
      </div>
      )}
      {props.checked && (
      <div className="proposal-part-circle-footer__keep-delete-switch">
        <KeepDeleteSwitch
          destroyCircleKeepRole={props.destroyCircleKeepRole}
          isReadonly={props.isReadonly}
          onChange={props.onChange}
          parentCircleName={props.parentCircleName}
          roleName={props.roleName}
        />
      </div>
      )}
    </div>
  )
}

export default CircleV4Footer
